import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.addressId
    ? _c(
        VMenu,
        {
          attrs: {
            "open-on-hover": !_setup.isMobile,
            "open-on-click": false,
            "open-on-focus": false,
            "offset-y": "",
            "close-on-content-click": false,
            "nudge-bottom": 8,
            "max-width": "none",
            "content-class": "lpu-card-schedule-menu",
          },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function ({ on, attrs }) {
                  return [
                    _c(
                      "div",
                      _vm._g(
                        _vm._b(
                          {
                            staticClass:
                              "text-body-2 primary--text cursor-pointer",
                            attrs: { "data-qa": "analyses_lpu_card_schedule" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _setup.onActivatorClick.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          "div",
                          attrs,
                          false
                        ),
                        _setup.isMobile ? {} : on
                      ),
                      [_vm._v("\n      " + _vm._s(_vm.scheduleText) + "\n    ")]
                    ),
                  ]
                },
              },
            ],
            null,
            false,
            2866187953
          ),
          model: {
            value: _setup.isOpen,
            callback: function ($$v) {
              _setup.isOpen = $$v
            },
            expression: "isOpen",
          },
        },
        [
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "lpu-card-schedule pa-4" },
            [
              _setup.isLoading && !_setup.schedule
                ? _c(
                    "div",
                    { staticClass: "lpu-card-schedule__skeleton" },
                    [_c(VSkeletonLoader, { attrs: { type: "text@14" } })],
                    1
                  )
                : _setup.schedule
                ? [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column gr-3" },
                      _vm._l(_setup.scheduleDays, function (day) {
                        return _c(
                          "div",
                          {
                            key: day,
                            staticClass: "d-flex gc-4",
                            class:
                              day === _setup.schedule.now_weekday_translit
                                ? "text-subtitle-1 text--text"
                                : "text-body-1 text-secondary--text",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "lpu-card-schedule__day flex-grow-1",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_setup.schedule.full_days[day]) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "flex-shrink-0" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_setup.schedule.schedule_days[day]) +
                                  "\n          "
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _setup.schedule.lpu_exceptions.length
                      ? [
                          _c(VDivider, { staticClass: "my-4" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column gr-3" },
                            [
                              _c(
                                "div",
                                { staticClass: "text-subtitle-1 text--text" },
                                [
                                  _vm._v(
                                    "\n            График работы в праздники\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _setup.schedule.lpu_exceptions,
                                function (exception, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: `holiday-${index}`,
                                      staticClass:
                                        "d-flex gc-4 text-body-1 text-secondary--text",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "lpu-card-schedule__day flex-grow-1",
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(exception.date) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "flex-shrink-0" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(exception.time) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      )
    : _c(
        "div",
        {
          staticClass: "text-body-2 primary--text",
          attrs: { "data-qa": "analyses_lpu_card_schedule" },
        },
        [_vm._v("\n  " + _vm._s(_vm.scheduleText) + "\n")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }